import React from 'react'
import PropTypes from 'prop-types'
import DebouncedInput from '../../../molecules/DebouncedInput'
import { useDDPReportContext } from './DDPReportContext'

/**
 * Composable search component for DDP Reports
 * Must be used within <DDPReportProvider>
 * Searches across all columns, shows parent rows if children match
 */
function DDPReportSearch ({ placeholder, className, style }) {
  const { globalFilter, setGlobalFilter } = useDDPReportContext()

  return (
    <DebouncedInput
      value={globalFilter}
      placeholder={placeholder || 'Search'}
      onChange={setGlobalFilter}
      className={className}
      style={style}
    />
  )
}

DDPReportSearch.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default DDPReportSearch
